/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Account_ManagerInputs */



/**
* | output |
* | --- |
* | "Account Manager" |
*
* @param {Signup_Compare_Account_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_account_manager = /** @type {((inputs?: Signup_Compare_Account_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Account_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "de") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "es") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Account Manager")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Account Manager")
	return /** @type {LocalizedString} */ ("Account Manager")
});